"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolStatsPaginatedListSchema = exports.PoolStatsListSchema = exports.PoolStatsSchema = void 0;
const zod_1 = require("zod");
const Amount_1 = require("./Amount");
const PaginationMetadata_1 = require("./PaginationMetadata");
exports.PoolStatsSchema = zod_1.z.object({
    id: zod_1.z.string({ required_error: 'id is required' }),
    address: zod_1.z.string({ required_error: 'address is required' }),
    shareTokenID: zod_1.z.string({ required_error: 'shareTokenID is required' }),
    shareTokenSupply: Amount_1.TokenAmountSchema,
    reserves: zod_1.z.array(Amount_1.TokenAmountSchema),
    apr: zod_1.z.number(),
    estimatedApr: zod_1.z.number().optional().nullable(),
});
exports.PoolStatsListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.PoolStatsSchema),
});
exports.PoolStatsPaginatedListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.PoolStatsSchema),
    metadata: PaginationMetadata_1.PaginationMetadataSchema,
});
